var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M8.26 10.782c-1.68-1.686-1.68-4.433 0-6.118l3.386-3.4c1.68-1.685 4.415-1.685 6.094 0 1.68 1.686 1.68 4.433 0 6.119l-3.216 3.229c-.18.186-.447.26-.698.194-.25-.066-.446-.262-.512-.514-.066-.251.008-.519.194-.7l3.217-3.229c1.134-1.139 1.134-2.94 0-4.079-1.135-1.138-2.93-1.138-4.064 0l-3.386 3.4c-1.134 1.138-1.134 2.94 0 4.078.186.181.26.449.194.7-.066.252-.261.448-.512.514-.25.066-.517-.008-.697-.194zm-7 6.954c-1.68-1.686-1.68-4.433 0-6.119l3.216-3.229c.18-.186.448-.26.698-.195.25.066.447.263.512.514.066.252-.008.52-.194.701l-3.217 3.23c-1.134 1.138-1.134 2.94 0 4.078 1.135 1.139 2.93 1.139 4.064 0l3.386-3.4c1.134-1.138 1.134-2.94 0-4.078-.186-.181-.26-.449-.194-.7.066-.252.261-.448.512-.514.25-.066.517.008.697.194 1.68 1.686 1.68 4.433 0 6.118l-3.386 3.4c-1.68 1.686-4.415 1.686-6.094 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.6fb18a145d49804e9a0f801d2794d3bb.svg";
export { ForwardRef as ReactComponent };